import * as _ from 'lodash';

var deepGroup = function (seq, keys) {
    if (!keys.length) return seq;
    var first = keys[0];
    var rest = keys.slice(1);
    return _.mapValues(_.groupBy(seq, first), (value) => { return deepGroup(value, rest) });
};
export default deepGroup;